import React from "react";
import { Routes, Route } from "react-router-dom";



import HomeTwo from "../themes/index/Home";
import About from "../pages/About"


import Verify from "../pages/Verify";
import SmartGo from "../pages/SmartGo";
import Use from "../pages/Use";

import Impressum from "../pages/Impressum";

import ScrollToTop from "./ScrollToTop";
import Intema from "../pages/Intema";
import Cfd from "../pages/Cfd";
import Hts from "../pages/Hts";
import Projects from "../pages/Projects";
import News from "../pages/News";
import NewsArticle from '../pages/NewsArticle';


const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomeTwo/>} />
        <Route path="/impressum" element={<Impressum/>} />
        <Route path="/home" element={<HomeTwo/>} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/smartgo" element={<SmartGo />} />
        <Route path="/CFD" element={<Cfd />} />
        <Route path="/HTSim" element={<Hts />} />
        <Route path="/use" element={<Use />} />
        <Route path="/intema" element={<Intema />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/news/:slug" element={<NewsArticle />} />
        <Route path="/news" element={<News />} />
       
      </Routes>
    </>
  );
};

export default AppRoutes;
